// Lightweight motion wrapper for optimized framer-motion usage
// Only imports what's needed, avoiding drag/pan modules

import { 
  motion,
  AnimatePresence,
  useScroll,
  useTransform,
  type MotionProps,
  type Variants
} from "framer-motion";

// Re-export only what we need
export { motion, AnimatePresence, useScroll, useTransform };
export type { MotionProps, Variants };

// Common animation variants for reuse (reduces repeated object creation)
export const fadeInUp: Variants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 }
};

export const fadeIn: Variants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1 }
};

export const scaleIn: Variants = {
  hidden: { opacity: 0, scale: 0.95 },
  visible: { opacity: 1, scale: 1 }
};

// Stagger container for children animations
export const staggerContainer: Variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};

// Reduced motion detection for accessibility and performance
export const prefersReducedMotion = 
  typeof window !== 'undefined' 
    ? window.matchMedia('(prefers-reduced-motion: reduce)').matches 
    : false;

// Simplified transition presets
export const springTransition = {
  type: "spring" as const,
  stiffness: 400,
  damping: 30
};

export const smoothTransition = {
  duration: 0.6,
  ease: [0.16, 1, 0.3, 1] as const
};
